import { Tooltip } from "antd";
import MultiPane from "@components/tabs-responsive/tabs-responsive";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { serverFetch } from "@server";
import Builds from "./builds";
import CyberSpace from "./cyber-space";
import Plugins from "./plugins";

const Support = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((s) => s.user);
  const [spaces, setSpaces] = useState([]);
  const [spacesLoading, setSpacesLoading] = useState(false);

  useEffect(() => {
    if (user?.support) {
      setSpacesLoading(true);
      serverFetch("Cyber/spaces")
        .then((data) => setSpaces(Array.isArray(data) ? data : []))
        .catch(() => setSpaces([]))
        .finally(() => setSpacesLoading(false));
    } else {
      setSpaces([]);
    }
  }, [user?.support]);

  const items = [
    {
      key: "/support",
      label: "Дистрибутивы",
      children: <Builds />,
    },
    {
      key: "/plugins",
      label: "Решения",
      children: <Plugins />,
    },
  ];

  if (!user?.support) {
    items.push({
      key: "cyber-disabled",
      selectLabel: "Киберинженер",
      label: (
        <Tooltip title="Для доступа необходимо иметь активную подписку">
          <span>Киберинженер</span>
        </Tooltip>
      ),
      disabled: true,
    });
  } else if (spacesLoading) {
    items.push({
      key: "cyber-loading",
      selectLabel: "Киберинженер",
      label: "Киберинженер",
      disabled: true,
      children: null,
    });
  } else if (spaces.length > 0) {
    spaces.forEach((s) => {
      if (s.vid === 0){
        items.push({
          key: `/support/${s.id}`,
          label: s.name,
          children: <CyberSpace spaceId={s.id} />,
        });
      }
    });
  } else {
    items.push({
      key: "cyber-empty",
      selectLabel: "Киберинженер",
      label: "Киберинженер",
      children: <div style={{ padding: 24, color: "#999" }}>Нет пространств</div>,
    });
  }

  const pathname = location.pathname;
  const activeKey =
    pathname.startsWith("/plugins")
      ? "/plugins"
      : items.find((item) => item.key === pathname)?.key || items[0]?.key;

  const onTabChange = (key) => {
    if (key === "cyber-disabled") return;
    navigate(key);
  };

  return (
    <div className="page support-page">
      <MultiPane
        activeKey={activeKey}
        items={items}
        onChange={onTabChange}
        type="card"
      />
    </div>
  );
};

export default Support;
